import { type RouteObject } from 'react-router-dom-v6'
import AppLayout from './components/AppLayout'
import PagePlaceholder from './components/PagePlaceholder'
import RouteError from './components/RouteError'
import { EditOAuthClient, OAuthClientsList, RegisterOAuthClient } from './features/oauthClients'
import { EditRole, RegisterRole, RolesList } from './features/roles'
import { EditServiceAccount, RegisterServiceAccount, ServiceAccountsList } from './features/serviceAccounts'
import { EditUser, InviteUser, RegisterUser, UsersList } from './features/users'

// Route map for the accounts customer-admin dashboard. Remaining screens are
// placeholders until each feature is built against the confirmed admin-API wire
// contract (/v1/admin/customers, /v1/accountsettings).
export const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppLayout />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <UsersList /> },
      {
        path: 'users',
        children: [
          { index: true, element: <UsersList /> },
          { path: 'invite', element: <InviteUser /> },
          { path: 'new', element: <RegisterUser /> },
          { path: ':id/edit', element: <EditUser /> },
        ],
      },
      {
        path: 'roles',
        children: [
          { index: true, element: <RolesList /> },
          { path: 'new', element: <RegisterRole /> },
          { path: ':product/:roleId/edit', element: <EditRole /> },
        ],
      },
      { path: 'company', element: <PagePlaceholder title="Company profile" /> },
      {
        path: 'apis',
        children: [
          { index: true, element: <OAuthClientsList /> },
          { path: 'new', element: <RegisterOAuthClient /> },
          { path: ':id/edit', element: <EditOAuthClient /> },
        ],
      },
      {
        path: 'service-accounts',
        children: [
          { index: true, element: <ServiceAccountsList /> },
          { path: 'new', element: <RegisterServiceAccount /> },
          { path: ':id/edit', element: <EditServiceAccount /> },
        ],
      },
      { path: 'settings', element: <PagePlaceholder title="Settings" /> },
      { path: '*', element: <PagePlaceholder title="Page not found" /> },
    ],
  },
]
